// extracted by mini-css-extract-plugin
export default {"KPISChart":"KPIsChart_KPISChart__ca7d8"};